import { createContext } from 'react';
import { ThemeMode } from '../constants';

interface ThemeContextValue {
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
}

const ThemeContext = createContext<ThemeContextValue | null>(null);

export default ThemeContext;
